export default class TooltipWrapperController {}
